import { mixpanelTrackEventFromBE } from '.';
import {
  ANNUAL_INCOME_OPTIONS,
  BODY_TYPES,
  INTERESTS_OPTIONS,
  NET_WORTH_OPTIONS,
  YES_NO_OPTIONS_OBJECT,
} from '../../components/join/constants';

interface IUserProperties {
  'Body Type'?: Array<string>;
  Height?: number;
  Children?: boolean;
  Smoking?: string;
  Drinking?: string;
  Education?: string;
  Occupation?: string;
  Income?: string;
  'Dating Intentions'?: Array<string>;
  'Net Worth'?: string;
  'Default Offer Set'?: boolean;
  'User Default Offer Amount'?: number;
}

export interface IMixpanelOnboardingCompleted {
  skippedStep?: number;
  formData: Record<string, any>;
}

export const mixpanelTrackOnboardingCompleted = async (data: IMixpanelOnboardingCompleted): Promise<void> => {
  const selectedInterestsLabel = options => {
    return INTERESTS_OPTIONS.reduce((accumulator, currentValue) => {
      const value = options?.[currentValue.value];
      
      if (typeof value !== 'undefined' && value) {
        return [...accumulator, currentValue.label];
      } else {
        return accumulator;
      }
    }, [] as Array<string>);
  };

  const isGenerous = data.formData[0].account_type === 1;
  const userProperties: IUserProperties = {
    'Body Type': BODY_TYPES[data.formData[1].body_type],
    Height: data.formData[1].height,
    Children: data.formData[isGenerous ? 2 : 3].children === 1 ? true : false,
    Smoking: YES_NO_OPTIONS_OBJECT[data.formData[isGenerous ? 2 : 3].smoking],
    Drinking: YES_NO_OPTIONS_OBJECT[data.formData[isGenerous ? 2 : 3]],
    Education: data.formData[isGenerous ? 3 : 4].education ?? '',
    Occupation: data.formData[isGenerous ? 3 : 4].occupation ?? '',
    Income: ANNUAL_INCOME_OPTIONS.find(item => item.value === data.formData[isGenerous ? 3 : 4].income)?.label ?? '',
    'Dating Intentions': selectedInterestsLabel(data.formData[1]),
    'Net Worth':
      NET_WORTH_OPTIONS.find(item => item.value === data.formData[isGenerous ? 3 : 4].net_worth)?.label ?? '',
    'Default Offer Set': data.formData[2].default_offer_amount > 0 ? true : false,
    'User Default Offer Amount': data.formData[2].default_offer_amount ?? 0,
  };

  // Exclude user properties with undefined values
  const listsToBeExclude = Object.keys(userProperties).filter(key => userProperties[key] === undefined);

  // Filter user properties
  const filteredUserProperties = Object.keys(userProperties).reduce((data, key) => {
    if (!listsToBeExclude.includes(key)) {
      data[key] = userProperties[key];
    }
    return data;
  }, {});

  await mixpanelTrackEventFromBE({
    event_name: 'Onboarding Steps Completed',
    payload: {
      user_properties: filteredUserProperties,
      event_properties: {
        'Step Skipped': data.skippedStep || 0,
      },
    },
  });
};
